let CSRFTOKEN;

const getDeviceId = () => {
  if (
    typeof amplitude !== 'undefined' &&
    amplitude.getInstance() &&
    amplitude.getInstance().options
  ) {
    return amplitude.getInstance().options.deviceId;
  } else {
    return '';
  }
};

const getCsrfToken = () => {
  CSRFTOKEN = CSRFTOKEN ||
    new Promise((resolve, reject) => {
      const tag = document.querySelector('meta[name="csrf-token"]');
      if (tag) {
        return resolve(tag.getAttribute('content'));
      }

      fetch('/csrf_token', {
        credentials: 'same-origin',
        method: 'GET',
      })
        .then((response) => {
          if (!response.ok) {
            reject(`http error: ${response.status}`);
            return;
          }
          return response.json();
        })
        .then((data) => resolve(data.csrf_token));
    });

  return CSRFTOKEN;
};

const scribdAuthorize = (options) => {
  const params = {
    from_source: options.from_source || '/',
    initial_view: options.initial_view || 'join',
    slideshow_id: options.slideshow_id,
    slideshow_key: options.slideshow_key,
    device_id: getDeviceId(),
    download: options.isDownload,
  };

  const form = new FormData();

  for (let [name, value] of Object.entries(params)) {
    if (value) {
      form.append(name, value);
    }
  }

  getCsrfToken().then((token) => {
    return fetch('/scribd/authorize', {
      credentials: 'same-origin',
      headers: {
        'X-CSRF-Token': token,
      },
      method: 'POST',
      body: form,
    })
      .then((response) => response.json())
      .then((data) => {
        const form = document.createElement('form');

        form.setAttribute('action', data.url);
        form.setAttribute('method', 'POST');

        for (let [name, value] of Object.entries(data.params)) {
          const input = document.createElement('input');
          input.setAttribute('type', 'hidden');
          input.setAttribute('name', name);
          input.value = value;

          form.appendChild(input);
        }

        document.body.appendChild(form);
        form.submit();
      });
  });
};

export default scribdAuthorize;
